/**
 *
 * Even though the BE returns an array of Product Tags,
 * the FE only shows the first one in the array
 *
 * Also, if there are no product tags but there is a discount description
 * for a discount of 0, then use the discount description as a product tag
 */ const getProductTag = (serverTags, price)=>{
    const defaultDescription = getZeroDiscountDescription(price);
    if (!serverTags.length && !defaultDescription) return undefined;
    if (serverTags.length) {
        var _key;
        return {
            iconKey: (_key = serverTags[0].key) !== null && _key !== void 0 ? _key : undefined,
            value: serverTags[0].value
        };
    }
    // When a product has a discount of zero, and no other product tags are defined,
    // use the discount description as a fallback product tag
    return {
        iconKey: '',
        value: defaultDescription || ''
    };
};
const getZeroDiscountDescription = (price)=>{
    const { discountedPrice , discountInfo , originalPrice  } = price;
    const { discountDescription  } = discountInfo || {};
    // If the discounted price is the same as the original price, that means there is a discount of 0
    if (discountedPrice !== originalPrice || !discountDescription) return undefined;
    return discountDescription;
};

export { getProductTag };
//# sourceMappingURL=get-product-tags.js.map
